// Carry Roll DiagnosticsScreen — Screen 5. Single column, 2 collapsibles.

import { Collapsible } from '../components/calculator/Collapsible';
import { StrikePanel } from '../components/diagnostics/StrikePanel';
import { FittingSignals } from '../components/diagnostics/FittingSignals';

export default function DiagnosticsScreen() {
  return (
    <div className="measure-content flex flex-col gap-4" data-testid="diagnostics-screen">
      <h2 className="section-title">
        Diagnostics
      </h2>
      <Collapsible title="Strike & dispersion" testId="diagnostics-strike">
        <StrikePanel />
      </Collapsible>
      <Collapsible title="Fitting signals" testId="diagnostics-fitting">
        <FittingSignals />
      </Collapsible>
    </div>
  );
}
